import { useField } from 'formik'
import Styles from './PaletteField.module.scss'
import { forwardRef } from 'react'
import { PaletteSwatch } from 'components/PaletteSwatch/PaletteSwatch'
import { useObjectRef } from '@react-aria/utils'
import useButtonWithScrollCancel from 'hooks/useButtonWithScrollCancel'
import { PaletteFieldDrawer, PaletteWithLabel } from './PaletteFieldDrawer'
import { useRootStore } from 'stores/RootStore'
import { Ref } from 'components/DesignContentPreview/Types'
import { PALETTES, Palette } from 'constants/palettes'
import { useFormBrandVisualKit } from 'components/Wizards/hooks/useFormBrandVisualKit'

interface Props {
  editorRef?: Ref
  templatePalette?: Palette
}

const PaletteField = forwardRef<HTMLDivElement, Props>(({ editorRef, templatePalette }, fRef) => {
  const [{ value: palette }, , { setValue: setPalette }] = useField('palette')
  const kit = useFormBrandVisualKit()
  const { drawersStore } = useRootStore()

  const ref = useObjectRef<HTMLDivElement>(fRef)

  const { buttonProps } = useButtonWithScrollCancel(
    {
      onPress: () => {
        let palettes: PaletteWithLabel[] = []
        if (templatePalette) {
          palettes = [{ palette: templatePalette }]
        }

        if (kit) {
          const kitPalette = kit.primary_color_palette.colors.map((color) => color.hex)

          if (kitPalette) {
            palettes = palettes.concat([
              {
                label: kit.name,
                palette: kitPalette,
              },
            ])
          }
        }

        palettes = palettes.concat(PALETTES.map((palette) => ({ palette })))
        drawersStore.openDrawer(PaletteFieldDrawer, {
          initialValue: palette,
          palettes,
          onSelect: (palette) => {
            setPalette(palette)
          },
          editorRef,
        })
      },
      elementType: 'div',
    },
    ref,
  )

  return (
    <div className={Styles.button} {...buttonProps} ref={ref}>
      <div className={Styles.paletteSwatch}>
        <PaletteSwatch colors={palette} />
      </div>
      <span className={Styles.label}>Change Colors</span>
    </div>
  )
})

export { PaletteField }
